class BogaPageTitleTitle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.titleNode = this;
    this.pageTitleNode = document.getElementsByClassName('page-title')[0];
    this.setTitleHeight();
    window.addEventListener('resize', () => this.setTitleHeight());
  }

  setTitleHeight() {
    const height = this.titleNode.getBoundingClientRect().height;
    this.pageTitleNode.style.setProperty('--page-title--title-height', `${height}px`);
    console.log(height);
  }
}

window.customElements.define('boga-page-title-title', BogaPageTitleTitle);
